const projectDetail = {
  notFound: "Project not found",
  backToLayers: "Back to Hub",
  layers: "Layers",
  layer: "Layer",
  source: "Source",
  health: "Health",
  status: "Status",
  documents: "Documents",
  newDoc: "New doc",
  noDocuments: "No documents yet",
  storyMap: "vStory",
  openMap: "Open map",
  noStoryCards: "No story cards yet",
  more: "more",
} as const;
export default projectDetail;
